import React from "react";
import Typical from "react-typical";
import Link from "../../../components/Link";
import SocialMediaLinks from "../../../components/SocialMediaLinks";
import ScrollService from "../../../utilities/ScrollService";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <SocialMediaLinks />
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'm{" "}
              <span className="highlighted-text">Ram Suryawanshi</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Full-Stack Web Developer",
                    1000,
                    "MERN Stack Developer",
                    1000,
                    "Node/Express Developer",
                    1000,
                    "React Developer ⚛️",
                    1000,
                    "Angular Developer 🅰️",
                    1000,
                    "Enthusiastic Dev 😎",
                    1000,
                  ]}
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
              Knack of building applications with front and back end operations.
            </span>
          </div>

          <div className="profile-options">
            <button
              className="btn primary-btn"
              onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              {" "}
              Hire Me{" "}
            </button>
            <Link href="ram-resume.pdf" download="RamCv.pdf">
              <button className="btn highlighted-btn">Get Resume</button>
            </Link>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
